// Mastery gate quiz bank — one 5-question quiz per phase
// Thresholds: Phase 1/2 = 85%, Phase 3/4 = 90%

export const PHASES = [
  {
    id: "phase1",
    name: "Phase 1 — Foundation & Mindset",
    threshold: 85,
    questions: [
      {
        q: "A doji candlestick primarily signals…",
        choices: ["Strong trend continuation", "Market indecision — buyers and sellers in balance", "A confirmed reversal", "A change in volatility only"],
        correct: 1,
      },
      {
        q: "A market is confirmed in a downtrend when it prints…",
        choices: ["Higher highs and higher lows", "Lower highs and lower lows", "Equal highs and equal lows", "Random candles with no pattern"],
        correct: 1,
      },
      {
        q: "In trading, 'confluence' means…",
        choices: [
          "Using a single indicator in isolation",
          "Multiple independent reasons to take a trade lining up at the same price",
          "A random coincidence of candles",
          "A specific candlestick pattern",
        ],
        correct: 1,
      },
      {
        q: "Which is the strongest sign of bullish structure?",
        choices: ["A break of a prior higher low", "A break of a prior lower high", "A new higher high with a higher low intact", "RSI above 50"],
        correct: 2,
      },
      {
        q: "The primary purpose of a trading plan is to…",
        choices: [
          "Guarantee profits every week",
          "Remove discretion and make your behavior repeatable",
          "Impress other traders",
          "Replace risk management rules",
        ],
        correct: 1,
      },
    ],
  },
  {
    id: "phase2",
    name: "Phase 2 — Technical Analysis",
    threshold: 85,
    questions: [
      {
        q: "RSI above 70 indicates…",
        choices: ["Oversold — expect a bounce", "Overbought — potential pullback zone", "Neutral momentum", "Trend confirmation only"],
        correct: 1,
      },
      {
        q: "A golden cross refers to…",
        choices: [
          "The 200 MA crossing below the 50 MA",
          "The 50 MA crossing above the 200 MA — bullish signal",
          "Any MA crossing the price",
          "A candlestick pattern",
        ],
        correct: 1,
      },
      {
        q: "Bearish divergence forms when…",
        choices: [
          "Price makes a new high but the oscillator does not",
          "Price and oscillator both make new highs",
          "Price makes a new low and the oscillator also",
          "The market ranges sideways",
        ],
        correct: 0,
      },
      {
        q: "Which statement about volume is MOST accurate?",
        choices: [
          "Volume confirms breakouts — a breakout with low volume is suspect",
          "Volume is irrelevant in trading",
          "Volume only matters on monthly charts",
          "Volume must always spike at tops",
        ],
        correct: 0,
      },
      {
        q: "A 'break of structure' (BOS) signals…",
        choices: [
          "That the current trend is about to continue forever",
          "A potential shift in market structure once a key swing is broken",
          "That a candle closed red",
          "Noise that should always be ignored",
        ],
        correct: 1,
      },
    ],
  },
  {
    id: "phase3",
    name: "Phase 3 — Risk & Strategy",
    threshold: 90,
    questions: [
      {
        q: "Account: $10,000. Risk: 1% per trade. Stop: 20 pips on EUR/USD (≈$10/pip). Risk in dollars and pip value?",
        choices: [
          "$200 at $10/pip",
          "$100 risk, so position size = $100 / 20 = $5 per pip",
          "$500 risk with full standard lot",
          "$50 risk with mini lot",
        ],
        correct: 1,
      },
      {
        q: "Maximum recommended portfolio heat (total risk across all open trades) for a beginner is…",
        choices: ["20%+", "10–15%", "Around 4–6%", "0% — never hold multiple trades"],
        correct: 2,
      },
      {
        q: "Drawdown is best defined as…",
        choices: [
          "Peak-to-trough decline before a new equity peak is made",
          "The spread paid on a trade",
          "A single losing trade",
          "The broker's commission",
        ],
        correct: 0,
      },
      {
        q: "Expectancy formula:",
        choices: [
          "Wins − Losses",
          "(Win Rate × Avg Win) − (Loss Rate × Avg Loss)",
          "Win Rate ÷ R:R",
          "Total Trades × Avg Risk",
        ],
        correct: 1,
      },
      {
        q: "A rule-based strategy without a tested edge is…",
        choices: [
          "Still guaranteed to make money",
          "Indistinguishable from gambling in the long run",
          "Always better than discretionary trading",
          "Only useful for forex",
        ],
        correct: 1,
      },
    ],
  },
  {
    id: "phase4",
    name: "Phase 4 — Live Execution & Scaling",
    threshold: 90,
    questions: [
      {
        q: "When scaling up risk after a profitable month, the BEST practice is…",
        choices: [
          "Double risk immediately",
          "Scale incrementally (e.g. +0.25% risk per milestone) with a hard drawdown cap",
          "Remove stop losses to give trades room",
          "Trade more pairs simultaneously without limits",
        ],
        correct: 1,
      },
      {
        q: "If you hit your daily loss limit, the correct action is…",
        choices: [
          "Size up to recover quickly",
          "Step away — daily limits are non-negotiable",
          "Switch to a new, unfamiliar market",
          "Trade in a lower timeframe to catch more setups",
        ],
        correct: 1,
      },
      {
        q: "Journaling every trade matters because…",
        choices: [
          "It's a legal requirement",
          "It turns noisy experience into data you can act on and improve",
          "It impresses prop firms",
          "It replaces a trading plan",
        ],
        correct: 1,
      },
      {
        q: "A prop-firm-style challenge most often fails due to…",
        choices: [
          "Undersized positions",
          "Breaking daily loss / overall drawdown rules while chasing targets",
          "Using a demo account",
          "Trading during London session",
        ],
        correct: 1,
      },
      {
        q: "When live performance deviates from backtest, the FIRST action is…",
        choices: [
          "Blame the market",
          "Reduce size and audit for rule deviations before changing the strategy",
          "Add new indicators",
          "Switch strategy entirely",
        ],
        correct: 1,
      },
    ],
  },
];

export const getPhase = (id) => PHASES.find((p) => p.id === id);
